import { post } from "jquery";

export function aarhusguidenEventPage(){
    const params = new URL(document.location).searchParams;
    const id = params.get('id');

    // if aarhusguiden script and id exist
    if(document.querySelector('#jsaarhusguidenpage') && id){
        const currentUrl = window.location.origin;
        const baseUrl = 'https://api.detskeriaarhus.dk/api/v2/events/'
        const url = `${baseUrl}${id}`
        const accessToken = 'iw1pvLnjtBM0AvNG7TeH7ZT4ukNYgpdAWxUZ96Rc';

        async function fetchData(){
            const response = await fetch(url, {
                headers: {
                    'Origin': currentUrl,
                    'X-Api-Key': accessToken
                }
            });
            const data = await response.json();

            const event = data['hydra:member'][0];

            if(event){
                const mainElement = document.querySelector('main')
                mainElement.classList.add('bg-main--white')

                //Create banner if there is an image
                if(event.imageUrls.large){
                    //use this in live (doesn't work with test api)
                    let imgSrc = event.imageUrls.large;
                    //let imgSrc = '../../../assets/img/demo/stockphoto-amager-tree.jpg'

                    let bannerSection = document.createElement('section');
                    bannerSection.classList.add('banner--absolute--height50vh')

                    //create banner
                    let banner = document.createElement('div')
                    banner.classList.add('banner', 'height-50vh');
                    banner.setAttribute('data-fullwidthimage', 'true')
                    bannerSection.appendChild(banner)

                    //create image container
                    let imageContainer = document.createElement('div')
                    imageContainer.classList.add('banner__image', 'media__container');
                    banner.appendChild(imageContainer)

                    //create img
                    let img = document.createElement('img')
                    img.classList.add('lazyloaded');
                    img.setAttribute('data-src', imgSrc)
                    img.setAttribute('src', imgSrc)
                    imageContainer.appendChild(img)

                    mainElement.appendChild(bannerSection)
                }


                let article = document.createElement('article');

                // Create container
                let container = document.createElement('div');
                container.classList.add('container');
                article.appendChild(container)

                //Create row
                let row = document.createElement('div');
                row.classList.add('row');
                container.appendChild(row)

                //Create col
                let col1 = document.createElement('div');
                col1.classList.add('col-md-12')
                row.appendChild(col1);

                //create article container
                let articleContainer = document.createElement('div');
                articleContainer.classList.add('article-container', 'bg--white');
                col1.appendChild(articleContainer);

                //create article wrapper
                let articleWrapper = document.createElement('section');
                articleWrapper.classList.add('article-wrapper')
                articleContainer.appendChild(articleWrapper)

                //create row 2
                let row2 = document.createElement('div')
                row2.classList.add('row');
                articleWrapper.appendChild(row2)

                //CREATE MAIN ARTICLE CONTENT
                let colMain = document.createElement('div');
                colMain.classList.add('col-md-12', 'col-lg-7', 'col-xl-7');
                row2.appendChild(colMain);

                // create hero article
                let heroArticle = document.createElement('div');
                heroArticle.classList.add('hero__article');
                colMain.appendChild(heroArticle);

                //create hero article text
                let heroArticleText = document.createElement('div')
                heroArticleText.classList.add('hero__article__text');
                heroArticle.appendChild(heroArticleText);

                //create tags
                let heroTagsOver = document.createElement('div');
                heroTagsOver.classList.add('hero__tags--over');
                heroArticleText.appendChild(heroTagsOver);

                //create tags container
                let tagsContainer = document.createElement('div');
                tagsContainer.classList.add('tags-container')
                heroTagsOver.appendChild(tagsContainer)

                //create each tag
                event.tags.forEach((item) => {
                    let tag = document.createElement('div');
                    tag.classList.add('tag', 'tag--default');
                    let capitalizedItem = item.charAt(0).toUpperCase() + item.slice(1); // Capitalize the first letter
                    tag.innerHTML = `<span>${capitalizedItem}</span>`;
                    tagsContainer.appendChild(tag)
                })
   
                //create h1
                let h1 = document.createElement('h1');
                h1.textContent = event.title;
                heroArticleText.appendChild(h1)

                //create excerpt
                let excerpt = document.createElement('p')
                excerpt.textContent = event.excerpt;
                heroArticleText.appendChild(excerpt)

                //create rich text 
                let richText = document.createElement('p');
                richText.classList.add('rich-text');
                richText.innerHTML = event.description;
                colMain.appendChild(richText)

                //CREATE SIDEBAR
                let colSide = document.createElement('div')
                colSide.classList.add('col-md-12', 'col-lg-4', 'offset-lg-1', 'col-xl-4', 'offset-xl-1')
                row2.appendChild(colSide)

                //create sidebox
                let sidebox = document.createElement('div')
                sidebox.classList.add('side-box', 'bg--grey-light')
                colSide.appendChild(sidebox)

                //create dynamicsidebox
                let sideboxDynamic = document.createElement('div');
                sideboxDynamic.classList.add('side-box__content');
                sidebox.appendChild(sideboxDynamic)

                //create sideboxtitle
                let sideboxTitle = document.createElement('h2');
                sideboxTitle.classList.add('h2');
                sideboxTitle.textContent = 'Oversigt';
                sideboxDynamic.appendChild(sideboxTitle)

                //create listIcons div
                let listIcons = document.createElement('div')
                listIcons.classList.add('list__icons');
                sideboxDynamic.appendChild(listIcons)

                //create listicons ul
                let ul = document.createElement('ul');
                listIcons.appendChild(ul);

                //create date li
                let months = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.']
                let dateLi = document.createElement('li');

                    // Create an SVG element
                    let dateSvg = document.createElement('svg');
                    dateSvg.classList.add('svg-date');
                    dateSvg.setAttribute('width', '19');
                    dateSvg.setAttribute('height', '21');
                    dateSvg.setAttribute('viewBox', '0 0 19 21');
                    dateSvg.setAttribute('fill', 'none');
                    dateSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                    
                    // Create and append a <path> element to the SVG
                    let path = document.createElement('path');
                    path.setAttribute('fill-rule', 'evenodd');
                    path.setAttribute('clip-rule', 'evenodd');
                    path.setAttribute('d', 'M3.04545 4.38635C2.31421 4.38635 1.75 4.95057 1.75 5.68181V17.9545C1.75 18.6858 2.31421 19.25 3.04545 19.25H15.3182C16.0494 19.25 16.6136 18.6858 16.6136 17.9545V5.68181C16.6136 4.95057 16.0494 4.38635 15.3182 4.38635H3.04545ZM0.25 5.68181C0.25 4.12214 1.48579 2.88635 3.04545 2.88635H15.3182C16.8778 2.88635 18.1136 4.12214 18.1136 5.68181V17.9545C18.1136 19.5142 16.8778 20.75 15.3182 20.75H3.04545C1.48579 20.75 0.25 19.5142 0.25 17.9545V5.68181Z');
                    path.setAttribute('fill', '#000');
                    dateSvg.appendChild(path);
                    
                    // Create and append a <rect> element to the SVG
                    let rect = document.createElement('rect');
                    rect.setAttribute('x', '1');
                    rect.setAttribute('y', '4');
                    rect.setAttribute('width', '16');
                    rect.setAttribute('height', '6');
                    rect.setAttribute('fill', '#000');
                    dateSvg.appendChild(rect);
                    
                    // Create and append a <path> element to the SVG
                    let path2 = document.createElement('path');
                    path2.setAttribute('fill-rule', 'evenodd');
                    path2.setAttribute('clip-rule', 'evenodd');
                    path2.setAttribute('d', 'M4.27246 0.25C4.68667 0.25 5.02246 0.585786 5.02246 1V4.27273C5.02246 4.68694 4.68667 5.02273 4.27246 5.02273C3.85825 5.02273 3.52246 4.68694 3.52246 4.27273V1C3.52246 0.585786 3.85825 0.25 4.27246 0.25Z');
                    path2.setAttribute('fill', '#000');
                    dateSvg.appendChild(path2);
    
                    // Create and append a <path> element to the SVG
                    let path3 = document.createElement('path');
                    path3.setAttribute('fill-rule', 'evenodd');
                    path3.setAttribute('clip-rule', 'evenodd');
                    path3.setAttribute('d', 'M14.0908 0.25C14.505 0.25 14.8408 0.585786 14.8408 1V4.27273C14.8408 4.68694 14.505 5.02273 14.0908 5.02273C13.6766 5.02273 13.3408 4.68694 13.3408 4.27273V1C13.3408 0.585786 13.6766 0.25 14.0908 0.25Z');
                    path3.setAttribute('fill', '#000');
                    dateSvg.appendChild(path3);

                dateLi.appendChild(dateSvg)
                //Get dates into string
                event.occurrences.forEach((item) => {
                    //if start and end are same day
                    if(item.end.substring(0,10) == item.start.substring(0,10)){
                        let day = item.start.substring(8,10);
                        let month = parseInt(item.start.substring(5,7))
                        let year = item.start.substring(0,4)
                        let string = `${day}. ${months[month-1]} ${year}`
                        let dateString = `${string}<br>`
                        if(dateString){
                            dateLi.innerHTML += dateString
                        }
                    } else {

                    }
                })

                ul.appendChild(dateLi)

                //Create time li
                let timeLi = document.createElement('li');

                    //Create time svg
                    let timeSvg = document.createElement('svg');
                    timeSvg.classList.add('svg-time');
                    timeSvg.setAttribute('width', '19')
                    timeSvg.setAttribute('height', '19')
                    timeSvg.setAttribute('viewBox', '0 0 19 19')
                    timeSvg.setAttribute('fill', 'none')
                    timeSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

                    let timeCircle = document.createElement('circle');
                    timeCircle.setAttribute('cx', '9.5')
                    timeCircle.setAttribute('cy', '9.5')
                    timeCircle.setAttribute('r', '8.75')
                    timeCircle.setAttribute('stroke', '#000')
                    timeCircle.setAttribute('stroke-width', '1.5')
                    timeSvg.appendChild(timeCircle)

                    let timePath = document.createElement('path')
                    timePath.setAttribute('d', 'M9.02539 4.27502V10.45L11.8754 13.3')
                    timePath.setAttribute('stroke', '#000')
                    timePath.setAttribute('stroke-width', '1.5')
                    timeSvg.appendChild(timePath)

                timeLi.appendChild(timeSvg)

                //get times
                let startTime = event.occurrences[0].start.substring(11, 16).replace(':','.')
                let endTime = event.occurrences[0].end.substring(11, 16).replace(':','.')
                //if no end time, show only start time
                if(endTime == startTime){
                    timeLi.innerHTML += startTime
                } else {
                    timeLi.innerHTML += `${startTime} - ${endTime}`
                }

                ul.appendChild(timeLi)



                //Create location li
                let locationLi = document.createElement('li');
                    //Create locationSvg
                    let locationSvg = document.createElement('svg');
                    locationSvg.classList.add('svg-location');
                    locationSvg.setAttribute('width', '16')
                    locationSvg.setAttribute('height', '21')
                    locationSvg.setAttribute('viewBox', '0 0 16 21')
                    locationSvg.setAttribute('fill', 'none')
                    locationSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
    
                    let locationPath = document.createElement('path');
                    locationPath.setAttribute('d', 'M8 0C3.6 0 0 3.6 0 8C0 9.73333 0.533333 11.4 1.6 12.8L8 21L14.4 12.8C15.4667 11.4 16 9.73333 16 8C16 3.6 12.4 0 8 0ZM8 10.8667C6.26667 10.8667 4.8 9.46667 4.8 7.66667C4.8 6 6.26667 4.53333 8 4.53333C9.73333 4.53333 11.2 5.93333 11.2 7.73333C11.2 9.46667 9.73333 10.8667 8 10.8667Z')
                    locationPath.setAttribute('fill', '#000')
                    locationSvg.appendChild(locationPath)

                locationLi.appendChild(locationSvg);
                let location = event.location ? event.location.name : '';
                let address = event.location? event.location.street : '';
                let postalcode = event.location ? event.location.postalCode : '';
                let city = event.location ? event.location.city : '';
                let locationString = `${location}<br>${address}<br>${postalcode} ${city}`

                locationLi.innerHTML += locationString;

                ul.appendChild(locationLi)

                //if price (and price is not 0), create price li
                if(event.occurrences[0].ticketPriceRange && event.occurrences[0].ticketPriceRange != 0){
                    let priceLi = document.createElement('li');
                    
                    let priceSvg = document.createElement('svg');
                    priceSvg.classList.add('svg-price');
                    priceSvg.setAttribute('width', '22')
                    priceSvg.setAttribute('height', '22')
                    priceSvg.setAttribute('viewBox', '0 0 22 22')
                    priceSvg.setAttribute('fill', 'none')
                    priceSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
 
                    let pricePath1 = document.createElement('path');
                    pricePath1.setAttribute('d', 'M14.2773 7.72229C13.6107 7.05562 13.6107 5.88896 14.2773 5.22229C14.944 4.55562 16.1107 4.55562 16.7773 5.22229C17.444 5.88896 17.444 7.05562 16.7773 7.72229C16.0551 8.44451 14.944 8.44451 14.2773 7.72229Z')
                    pricePath1.setAttribute('stroke', '#000')
                    pricePath1.setAttribute('stroke-width', '1.5')
                    pricePath1.setAttribute('stroke-miterlimit', '10')
                    priceSvg.appendChild(pricePath1);
 
                    let pricePath2 = document.createElement('path')
                    pricePath2.setAttribute('d', 'M18.9412 1H13.6471C12.6471 1 11.7059 1.41298 11 2.12094L1.70588 11.3835C1.23529 11.8555 1 12.4454 1 13.0944C1 13.7434 1.23529 14.3333 1.70588 14.8053L7.17647 20.292C7.64706 20.764 8.23529 21 8.88235 21C9.52941 21 10.1176 20.764 10.5882 20.292L19.8824 11.0295C20.5882 10.3215 21 9.37758 21 8.37463V3.0649C21 1.94395 20.0588 1 18.9412 1Z')
                    pricePath2.setAttribute('stroke', '#000')
                    pricePath2.setAttribute('stroke-width', '2')
                    pricePath2.setAttribute('stroke-miterlimit', '10')
                    priceSvg.appendChild(pricePath2)
 
                    priceLi.appendChild(priceSvg)
                    priceLi.innerHTML += `${event.occurrences[0].ticketPriceRange}`
                    ul.appendChild(priceLi)
                     
                 }
                //if url, add link to sidebox
                if(event.url){
                    let linkLi = document.createElement('li');

                    let linkSvg = document.createElement('svg');
                    linkSvg.classList.add('svg-link');
                    linkSvg.setAttribute('width', '22')
                    linkSvg.setAttribute('height', '21')
                    linkSvg.setAttribute('viewBox', '0 0 22 21')
                    linkSvg.setAttribute('fill', 'none')
                    linkSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg')

                    let linkPath1 = document.createElement('path');
                    linkPath1.setAttribute('d', 'M20.2 1.5C18.2 -0.5 15.1 -0.5 13.1 1.5L9.9 4.7C11.2 4.3 12.4 4.7 13.6 5.3L15.3 3.6C16.1 2.8 17.3 2.8 18.1 3.6C18.9 4.4 18.9 5.6 18.1 6.4L15.6 8.9L14 10.5C13.2 11.3 12 11.3 11.2 10.5L9 12.7C9.5 13.2 10.1 13.6 10.7 13.8C12.3 14.5 14.3 14.2 15.7 13.1C15.8 13 16 12.9 16.1 12.7L18.7 10.1L20.3 8.5C22.2 6.6 22.2 3.4 20.2 1.5Z')
                    linkPath1.setAttribute('fill', '#000')
                    linkSvg.appendChild(linkPath1);

                    let linkPath2 = document.createElement('path');
                    linkPath2.setAttribute('d', 'M9.30039 15.2L7.40039 17.1C6.60039 17.9 5.40039 17.9 4.60039 17.1C3.80039 16.3 3.80039 15.1 4.60039 14.3L8.80039 10.1C9.60039 9.29997 10.8004 9.29997 11.6004 10.1L13.7004 7.99997C13.2004 7.49997 12.6004 7.09997 12.0004 6.89997C10.3004 6.19997 8.30039 6.49997 6.80039 7.79997C6.70039 7.89997 6.70039 7.89997 6.60039 7.99997L2.40039 12.2C0.400391 14.2 0.400391 17.3 2.40039 19.3C4.40039 21.3 7.50039 21.3 9.50039 19.3L13.3004 15.5C11.4004 15.9 11.0004 15.8 9.30039 15.2Z')
                    linkPath2.setAttribute('fill', '#000');
                    linkSvg.appendChild(linkPath2)
                    linkLi.appendChild(linkSvg)

                    let eventLink = document.createElement('a');
                    eventLink.setAttribute('href', event.url);
                    eventLink.textContent = `Læs mere hos arrangøren`
                    linkLi.appendChild(eventLink);
                    linkLi.innerHTML += ''

                    ul.appendChild(linkLi)
                }
                //if ticket url, create button
                if(event.ticketUrl){
                    let btnContainer = document.createElement('div')
                    btnContainer.classList.add('btn-container');
                    sideboxDynamic.appendChild(btnContainer)

                    let btnLink = document.createElement('a');
                    btnLink.classList.add('btn', 'btn__primary');
                    btnLink.setAttribute('href', event.ticketUrl)
                    btnLink.textContent = 'Billetter'
                    btnContainer.appendChild(btnLink)
                }


                //append article to main
                mainElement.appendChild(article)

            }
        }
        fetchData();

    }
}

export default aarhusguidenEventPage